export default {
  path: '/relatorios-ipem/:id',
  component: () => import('@/components/pages/IPEMReports/IPEMReport.vue')
}
